import FormButton from '@/shared/components/questionnaires/FormButton'
import Spinner from '@/shared/components/Spinner'
import React from 'react'
import { useFormikContext } from 'formik'

type Props = {
  backButtonState: 'enabled' | 'disabled' | 'hidden'
  backButtonLabel?: string

  nextButtonState: 'enabled' | 'disabled' | 'hidden' | 'loading'
  nextButtonLabel?: string

  submitButtonState: 'enabled' | 'disabled' | 'hidden'
  submitButtonLabel?: string

  onBackButtonClick: () => void
  onNextButtonClick: () => void
}

export default function FormButtonGroup({
  backButtonState,
  nextButtonState,
  submitButtonState,
  onBackButtonClick,
  onNextButtonClick,
  backButtonLabel = 'Back',
  nextButtonLabel = 'Next',
  submitButtonLabel = 'Submit',
}: Props) {
  const formik = useFormikContext()

  return (
    <div className="mt-6 flex items-center justify-end gap-x-6">
      {backButtonState !== 'hidden' && (
        <FormButton
          variant="secondary"
          disabled={backButtonState === 'disabled'}
          onClick={onBackButtonClick}
          type="button"
        >
          {backButtonLabel}
        </FormButton>
      )}
      {nextButtonState !== 'hidden' && (
        <FormButton
          id="questionnaire-next-button"
          variant="primary"
          disabled={
            nextButtonState === 'disabled' || nextButtonState === 'loading'
          }
          onClick={onNextButtonClick}
          type="button"
        >
          <div className="flex items-center justify-center gap-x-2">
            {nextButtonState === 'loading' && <Spinner />} {nextButtonLabel}
          </div>
        </FormButton>
      )}
      {submitButtonState !== 'hidden' && (
        <FormButton
          id="questionnaire-submit-button"
          variant="primary"
          disabled={formik.isSubmitting || submitButtonState === 'disabled'}
          type="submit"
        >
          <div className="flex items-center justify-center gap-x-2">
            {formik.isSubmitting && <Spinner />} {submitButtonLabel}
          </div>
        </FormButton>
      )}
    </div>
  )
}
